const getFormErrorMessage = (name = "") => {
    return name ? <small className="p-error">{name?.message}</small> : <small className="p-error"></small>;
};

export default getFormErrorMessage;